import { createStore, createEvent } from 'effector';
import { PrintersStoreState } from './PrintersStore.types';
import { fetchPrintersFx, createPrinterFx, deletePrinterFx } from './PrintersStore.effects';

const initialState: PrintersStoreState = {
    printers: [],
    loading: false,
    error: null,
};

export const clearPrintersError = createEvent('clearPrintersError');

export const PrintersStore = createStore<PrintersStoreState>(initialState)
    // Fetch
    .on(fetchPrintersFx.pending, (state, loading) => ({ ...state, loading, error: null }))
    .on(fetchPrintersFx.doneData, (state, printers) => ({ ...state, printers }))
    .on(fetchPrintersFx.failData, (state, error) => ({ ...state, error: error.message }))

    // Create
    .on(createPrinterFx.pending, (state, loading) => ({ ...state, loading, error: null }))
    .on(createPrinterFx.doneData, (state, newPrinter) => ({
        ...state,
        printers: [...state.printers, newPrinter],
    }))
    .on(createPrinterFx.failData, (state, error) => ({ ...state, error: error.message }))

    // Delete
    .on(deletePrinterFx.pending, (state, loading) => ({ ...state, loading, error: null }))
    .on(deletePrinterFx.done, (state, { params: deletedId }) => ({
        ...state,
        printers: state.printers.filter(p => p.id !== deletedId),
    }))
    .on(deletePrinterFx.failData, (state, error) => ({ ...state, error: error.message }))

    // Clear error
    .on(clearPrintersError, (state) => ({ ...state, error: null }));
